export function savedResumeSelection(batch){
  return {stt:[...(batch.transcription_provider_ids||[])],tr:[...(batch.translation_provider_ids||[])]};
}
export function validResumeSelection(providers,stt,tr,translation){
  const valid=(ids,field)=>ids.length>0&&ids.every(id=>providers.some(p=>p.id===id&&p.active&&typeof p[field]==='string'&&p[field].trim()));
  return valid(stt,'transcription_model')&&(!translation||valid(tr,'translation_model'));
}
